import type { ButtonSize, ButtonVariant } from "./Button.types";

export const variantClassMap: Record<ButtonVariant, string> = {
  primary: "Primary",
  secondary: "Secondary",
  tertiary: "Tertiary",
  danger: "Danger",
  "link-accent": "LinkAccent",
  "link-inverse": "LinkInverse",
  text: "Text",
};

export const sizeClassMap: Record<ButtonSize, string> = {
  xs: "SizeXs",
  sm: "SizeSm",
  md: "SizeMd",
  lg: "SizeLg",
  xl: "SizeXl",
};
